export function useBackgroundColor() {
  const time = new Date().getHours();

  return time >= 18 && time <= 21 ? '#ffc291' : '#91eaff';
}
